import React from "react";
import { useParams } from "react-router-dom";
import { UserDetails } from "../../components/UserDetails";

const UserDetailsPage = () => {
  const { userId } = useParams<{ userId: string }>();

  if (!userId) {
    return <div>User ID not found</div>;
  }

  return <UserDetails />;
};

export default UserDetailsPage;
